import React from 'react';
import './AddCard.css';

const AddCard = ({ onClick }) => {
  return (
    <div className="add-card" onClick={onClick}>
      <div className="add-icon">+</div>
    </div>
  );
};

export default AddCard;
